import { Check } from "lucide-react";

/**
 * Checkbox — kit-styled checkbox. All chrome lives in CSS class
 * `.d-checkbox` (see `dashboard-tokens.css`). The component renders a
 * hidden native `<input>` paired with a `<span class="box">` that the
 * CSS styles based on the input's `:checked` / `:focus-visible` state.
 *
 * Optional `label` renders as inline-flex sibling — pass it when the
 * checkbox lives standalone (settings list, filter row). For tables /
 * dense rows where the label is rendered separately, omit it.
 *
 * Back-compat: `onChange` receives the native `ChangeEvent`, callers
 * that previously read `e.target.checked` keep working without changes.
 */
interface CheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  id?: string;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export function Checkbox({
  checked,
  onChange,
  name,
  id,
  label,
  disabled,
  className = "",
}: CheckboxProps) {
  return (
    <label className={`d-checkbox ${disabled ? "is-disabled" : ""} ${className}`}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="box">
        <Check strokeWidth={3} />
      </span>
      {label && <span>{label}</span>}
    </label>
  );
}
